import React, { useState, useEffect, useContext, useMemo } from "react";
import { pdfHeader, pdfTableStyles, pdfFooter } from "../../../../pdfUtils";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable"
import useFullPageLoader from "../../../hooks/useFullPageLoader"

function AnalisisArticulosPedidos() {
  const { user } = useContext(AuthContext);
  const URL_INVENTARIOS = `${process.env.REACT_APP_URL_INVENTARIOS}`;
  const URL_SEGUIMIENTOS = `${process.env.REACT_APP_URL_SEGUIMIENTOS}`;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");




  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");



    //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50


  useEffect(() => {
       axios
      // Version ligera (solo codigo/nombre): el endpoint completo devuelve
      // ~12 MB y tardaba ~11 s, la vista parecia no cargar.
      .get(`${URL_ARTICULOS}Select`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    // Todos los renglones de pedidos no cancelados, de una vez.
    // El selector de articulo ya no dispara la consulta: solo filtra.
    showLoader();
    axios
      .get(`${URL_ARTICULOS_PEDIDO}Analisis`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setComments(response.data);
        hideLoader();
      })
      .catch((err) => {
        console.log(err);
        hideLoader();
      });

  }, []);

  // Solo filtra lo que ya esta cargado
  function BuscaArticulo(event) {
    setSelectedArticulo(event.target.value);
  }

  // Misma fuente para la tabla y para PDF/Excel/mail: lo que ves es lo que sale
  function datosFiltrados() {
    let data = comments;
    if (selectedArticulo) {
      data = data.filter((c) => String(c.idArticulo) === String(selectedArticulo));
    }
    if (search) {
      const q = search.toLowerCase();
      data = data.filter(
        (c) =>
          (c.cliente || "").toLowerCase().includes(q) ||
          (c.codigo || "").toLowerCase().includes(q) ||
          (c.articulo || "").toLowerCase().includes(q) ||
          (c.fecha || "").toLowerCase().includes(q) ||
          c.idPedido.toString().includes(search) ||
          c.cantidad.toString().includes(search) ||
          c.surtido.toString().includes(search) ||
          c.pendiente_surtir.toString().includes(search)
      );
    }
    return data;
  }

  function PDFTabla() {
    const data = datosFiltrados().map((a) => {
        return [
          a.idPedido,
          a.fecha,
          a.codigo,
          a.cliente,
          // a.area,
          a.autorizadoApartado,
          a.autorizadoSurtido,
          a.cantidad,
          a.surtido,
          a.pendiente_surtir
        ];
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    const inicioPDF = pdfHeader(doc, `Analisis Pedidos`);
    doc.autoTable({
      ...pdfTableStyles(),
      startY: inicioPDF,
      head: [
        [
          "Pedido",
          "Fecha",
          "Codigo",
          "Cliente",
          // "Almacen",
          "Apartado",
          "Aut Surtir",
          "Cantidad",
          "Surtido",
          "Pend Surtir",
        ],
      ],
      body: dataPDFLimpia,
      
      
      
      
    });
    pdfFooter(doc);
    doc.save(`Analisis-Pedidos.pdf`);
  }

  function excel() {
    const dataExcel = datosFiltrados().map((a) => {
        return {
          Pedido: a.idPedido,
          Fecha: a.fecha,
          Codigo: a.codigo,
          Articulo: a.articulo,
          Cliente: a.cliente,
          // Almacen: a.area,
          AutorizadoApartado: a.autorizadoApartado,
          AutorizadoSurtido: a.autorizadoSurtido,
          Cantidad: a.cantidad,
          Surtido: a.surtido,
          PendienteSurtir: a.pendiente_surtir
        };
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "AnalisisPedidos";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "AnalisisPedidos",
        sheetFilter: [
          "Pedido",
          "Fecha",
          "Codigo",
          "Articulo",
          "Cliente",
          // "Almacen",
          "AutorizadoApartado",
          "AutorizadoSurtido",
          "Cantidad",
          "Surtido",
          "PendienteSurtir",
        ],
        sheetHeader: [
          "Pedido",
          "Fecha",
          "Codigo",
          "Articulo",
          "Cliente",
          // "Almacen",
          "AutorizadoApartado",
          "AutorizadoSurtido",
          "Cantidad",
          "Surtido",
          "PendienteSurtir",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }



  const headers = [
    { name: "Pedido", field: "idPedido", sortable: false },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Articulo", field: "articulo", sortable: true },
    { name: "Cliente", field: "cliente", sortable: true },
    // { name: "Almacen", field: "area", sortable: true },
    { name: "Apartado", field: "autorizadoApartado", sortable: true },
    { name: "Aut Surtir", field: "autorizadoSurtido", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: false },
    { name: "Surtido", field: "surtido", sortable: false },
    { name: "Pend Surtir", field: "pendiente_surtir", sortable: false },
];



  const commentsData = useMemo(() => {
    let computedComments = datosFiltrados();


    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
        const reversed = sorting.order === "asc" ? 1 : -1;
        computedComments = [...computedComments].sort(
            (a, b) =>
                reversed * String(a[sorting.field] ?? "").localeCompare(String(b[sorting.field] ?? ""))
        );
    }

    //Current Page slice
    return computedComments.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
}, [comments, currentPage, search, sorting, selectedArticulo]);



  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          <Row>
            <Col md={10}>
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={2}>
                  {user.exportar ? (
                  <ButtonGroup id="logoutBoton">
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={PDFTabla}
                    >
                      PDF <i class="far fa-file-pdf"></i>
                    </Button>
                   
                    <Button
                      size="sm"
                      className="btn"
                      color="primary"
                      onClick={excel}
                    >
                      Excel <i class="far fa-file-excel"></i>
                    </Button>
                  </ButtonGroup>
                  ) : null}
                </Col>
          </Row>
         
      
          <h3 align="center">Analisis Articulos Pedidos</h3>
          <div className="row">
          <div className="col-md-2">
            <Label>Codigo QR</Label>
          </div>
          <div className="col-md-2">
            <Label>Codigo</Label>
          </div>
          <div className="col-md-2">
            <Label>Articulo</Label>
          </div>
          </div>
          <div className="row">
          <div className="col-md-2">
                        <Input
                            bsSize="sm"
                            type="text"
                            value={selectedArticulo}
                            onChange={(e) => {
                              BuscaArticulo(e)
                              setCurrentPage(1)
                            }}
                          >
                          </Input>
                          </div>
                        <div className="col-md-2">
                        <Input
                            bsSize="sm"
                            type="select"
                            value={selectedArticulo}
                            onChange={(e) => {
                              BuscaArticulo(e)
                              setCurrentPage(1)
                            }}
                          >
                            <option value="">Selecciona</option>
                            {articulos
                              .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                              .map((a) => {
                                return <option value={a._id}>{a.codigo} </option>;
                              })}
                          </Input>
                          </div>

                          <div className="col-md-2">
                        <Input
                            bsSize="sm"
                            type="select"
                            value={selectedArticulo}
                            onChange={(e) => {
                              BuscaArticulo(e)
                              setCurrentPage(1)
                            }}
                          >
                            <option value="">Selecciona</option>
                            {articulos
                              .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                              .map((a) => {
                                return <option value={a._id}>{a.codigo} </option>;
                              })}
                          </Input>
                          </div>
                         
                        <div className="col-md-6 d-flex flex-row-reverse">
                            <Search
                                onSearch={value => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                }}
                            />
                        </div>
                        
                    </div>
                    <br />





                    {/* Tabla Movimientos */}
                     <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />

          <Table size="sm" striped borderless className="table-responsive-xl">
                <TableHeader
                            headers={headers}
                            onSorting={(field, order) =>
                                setSorting({ field, order })
                            }
                        />
                      
            <tbody>
              {commentsData.map((a) => {
                  return (
                    <tr>
                      <td>{a.idPedido}</td>
                      <td>{a.fecha}</td>
                      <td>{a.codigo}</td>
                      <td>{a.articulo}</td>
                      <td>{a.cliente}</td>
                      {/* <td>{a.area}</td> */}
                      <td>{a.autorizadoApartado}</td>
                      <td>{a.autorizadoSurtido}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.surtido)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.pendiente_surtir)}</td>
                    </tr>
                  )
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
        </div>
      ) : undefined}


      {loader}
    </>
  );
}

export default AnalisisArticulosPedidos;
